<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <v-list>
        <v-select
        class="ma-2"        
        :items="languages"
        v-model="langInput"
        color="success"
        item-text="language"
        item-value="language"
        return-object
        v-on:change="changeRoute"
        label="Select language"
        ></v-select>
        <v-divider></v-divider>
        <v-list-tile
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link"
          class="dark--text"
        >
          <v-list-tile-action>
            <v-icon left>{{item.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title> {{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      fixed
      class="dark--text elevation-0"
      id="toolbar"
    >
      <v-toolbar-side-icon 
      class="hidden-md-and-up"
      @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link
        v-if="!spanish && !chinese"
        to="/" 
        tag="span" 
        style="cursor: pointer">
          <img src="@/assets/logo.png" style="height: 80px">
        </router-link>
        <router-link
        v-if="spanish"
        to="/es" 
        tag="span" 
        style="cursor: pointer">
          <img src="@/assets/logo.png" style="height: 80px">
        </router-link>
        <router-link
        v-if="chinese"
        to="/cn" 
        tag="span" 
        style="cursor: pointer">
          <img src="@/assets/logo.png" style="height: 80px">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-select
        class="ma-1"
        :items="languages"
        v-model="langInput"
        color="success"
        item-text="language"
        item-value="route"
        return-object
        v-on:change="changeRoute"
        label="Select language"   
        ></v-select>
        <v-btn 
        flat 
        v-for="item in menuItems" 
        :key="item.title"
        :to="item.link"
        class="dark--text"
        >
          <v-icon left>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content class="mt-4 pt-3">
      <router-view/>
    </v-content>
    <v-footer class="ml-3 transparent" app>
      <span>&copy; Exicon Investment Banking 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      drawer: false,
      languages: [
        {
          language: 'English',
          route: '/'
        },
        {
          language: 'Español',
          route: '/es'
        },
        {
          language: '中文',
          route: '/cn'
        }
      ],
      langInput: ''
    }
  },
  // guard nav items according to user login status
  computed: {
    menuItems () {
      let menuItems = [
        {
          icon: 'info',
          title: 'About Exicon',
          link: '/info'
        },
        {
          icon: 'room_service',
          title: 'Our Services',
          link: '/services'
        },
        {
          icon: 'mail',
          title: 'Contact Us',
          link: '/contact'
        }
      ]
      if (this.spanish) {
        menuItems = [
          {
            icon: 'info',
            title: 'Acerca Exicon',
            link: '/es/acerca'
          },
          {
            icon: 'room_service',
            title: 'Nuestro Servicios',
            link: '/es/servicios'
          },
          {
            icon: 'mail',
            title: 'Contáctenos',
            link: '/es/contacto'
          }
        ]
      }
      if (this.chinese) {
        menuItems = [
          {
            icon: 'info',
            title: '关于 Exicon',
            link: '/cn/about'
          },
          {
            icon: 'room_service',
            title: '我们的服务',
            link: '/cn/services'
          },
          {
            icon: 'mail',
            title: '联系我们',
            link: '/cn/contact'
          }
        ]
      }
      return menuItems
    },
    spanish () {
      return this.langInput.language === 'Español'
    },
    chinese () {
      return this.langInput.language === '中文'
    }
  },
  methods: {
    changeRoute (a) {
      this.$router.push({ path: a.route })
    }
  },
  name: 'App'
}
</script>

<style scoped>
  #toolbar {
    opacity: 0.9;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue